<template>
  <div class="pag-nav" v-if="totalPagesCount">
    <template v-for="(page, index) in pagesNumerics">
      <div v-if="!page" class="dots" :key="`x${index}`">
        . . .
      </div>
      <div v-else
        class="one"
        :key="page"
        :class="{ active: (page - 1) === pagination.page }"
        @click="$emit('change', page - 1)">
      {{ page }}
    </div>
    </template>
  </div>
</template>

<script>
// TODO:
// possibly rewrite
// An example in procedural style:
// https://gist.github.com/kottenator/9d936eb3e4e3c3e02598#file-simple-pagination-js-L3
export default {
  props: ['pagination', 'total'],
  computed: {
    // @source https://gist.github.com/kottenator/9d936eb3e4e3c3e02598#gistcomment-2899014
    pagesNumerics() {
      const currentPage = this.pagination.page + 1
      const pageCount = this.totalPagesCount
      const separate = (a, b) => ({
        0: [a],
        1: [a, b],
        2: [a, a + 1, b],
      }[b - a] || [a, null, b])

      return Array(3)
        .fill()
        .map((_, index) => currentPage - 1 + index)
        .filter(page => page > 0 && page <= pageCount)
        .flatMap((page, index, { length }) => {
          if (!index) return separate(1, page)
          if (index === length - 1) return separate(page, pageCount)
          return [page]
        })
    },
    totalPagesCount() {
      return Math.ceil(this.total / this.pagination.perPage)
    },
  },
}
</script>

<style lang="scss">
@import '~style/variables';

.pag-nav {
  text-align: center;
  padding-bottom: 2rem;
  > .dots {
    display: inline-block;
    font-size: $h3;
    transform: translateY(-0.125rem);
  }
  > .one {
    background: #fff;
    border: 1px solid $c-border;
    border-radius: $r;
    cursor: pointer;
    display: inline-block;
    margin: 0 0.5rem;
    padding: 0.5rem 1rem;
    &:hover {
      background: $c-grey;
    }
    &.active {
      border-color: $c-success;
      background: $c-success;
      color: #fff;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/components/PaginationNav.vue